// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"zo-z","badgeLink":"Ao-z","category":"Bo-z"};